export default "<p>tabs works!</p>\r\n";